// extracted by mini-css-extract-plugin
export var bodySections = "_bo-8";
export var gray = "_bo-7";
export var green = "_bo-4";
export var iconContainer = "_bo-9";
export var iconWidgetContainer = "_bo-1";
export var phoneIcon = "_bo-2";
export var red = "_bo-5";
export var statusDot = "_bo-3";
export var widgetContainer = "_bo-0";
export var yellow = "_bo-6";